module.exports = __webpack_public_path__ + "img/feature_low_latency.f1613e59.png";